import { render, staticRenderFns } from "./EditService.vue?vue&type=template&id=90bb4484&"
import script from "./EditService.vue?vue&type=script&lang=js&"
export * from "./EditService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports